'use client';

import { cn } from '@core/utils';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { Event } from '@/app/donation/_components/Event';
import { InviteFooter } from '@/app/donation/invite/_components/InviteFooter';
import { Image, PageNavigation } from '@/components/client';
import { CenteredDetailTemplate } from '@/components/template/CenteredDetailTemplate';

import { INVITE_COMMON_CONFIG } from '../../../constants';
import { INVITER_SECTION_IMAGES } from '../../constants';
import { BottomSection } from './BottomSection';
import { PrizeSection } from './PrizeSection';
import { RecentWinnersSection } from './RecentWinnersSection';

const BANNER_IMAGE_WIDTH = 850;

export const InvitePageTemplate = () => {
  const currentEventKey = INVITE_COMMON_CONFIG.event.eventKey;
  const sectionImages =
    currentEventKey && currentEventKey in INVITER_SECTION_IMAGES
      ? INVITER_SECTION_IMAGES[
          currentEventKey as keyof typeof INVITER_SECTION_IMAGES
        ]
      : Object.values(INVITER_SECTION_IMAGES).at(-1);

  return (
    <CenteredDetailTemplate>
      <div className="relative flex flex-col items-center bg-Gray-white">
        <Event />

        <PageNavigation donationHomeButton hideHomeButton />

        {sectionImages?.map((item) => (
          <Image
            key={item.src}
            className={cn('w-full', item.className)}
            src={item.src}
            alt="웰로 고향사랑기부 친구 초대 이벤트"
            width={BANNER_IMAGE_WIDTH}
            height={500}
          />
        ))}

        <ErrorBoundary fallback={null}>
          <Suspense>
            <div className="relative flex w-full flex-col gap-90 bg-B-400 px-20 py-80">
              <section className="flex w-full flex-col items-center gap-36">
                <RecentWinnersSection />
                <PrizeSection />
              </section>
            </div>
          </Suspense>
        </ErrorBoundary>

        <InviteFooter />
        <BottomSection />
      </div>
    </CenteredDetailTemplate>
  );
};
